module.exports = __webpack_public_path__ + "static/YoureFired-208b74d513bedc70166867417fdc3532.jpg";